(() => {
  const deferredVideoSelector = 'template[data-stormcrew-deferred-video]';
  const hydratedAttr = 'data-stormcrew-video-hydrated';

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const savesData = () => navigator.connection?.saveData === true;

  const runWhenIdle = (callback, timeout = 2600) => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout });
      return;
    }

    window.setTimeout(callback, Math.min(timeout, 1200));
  };

  const hydrateVideo = (template) => {
    if (!template || template.hasAttribute(hydratedAttr)) return;

    const container = template.closest('.slide__image-container');
    if (!container) return;

    const fragment = template.content.cloneNode(true);
    const video = fragment.querySelector('video');
    if (!video) return;

    template.setAttribute(hydratedAttr, 'true');
    video.muted = true;
    video.playsInline = true;
    video.preload = 'metadata';
    container.append(fragment);
    container.classList.add('has-loaded-deferred-video');

    const playPromise = video.play?.();
    if (playPromise?.catch) playPromise.catch(() => {});
  };

  const initDeferredVideos = () => {
    const templates = Array.from(document.querySelectorAll(deferredVideoSelector));
    if (!templates.length || prefersReducedMotion()) return;

    const hydrateFirst = () => {
      const firstVisible = templates.find((template) => {
        const slide = template.closest('slideshow-slide');
        return !slide || slide.getAttribute('aria-hidden') !== 'true';
      });

      if (firstVisible && !savesData()) {
        hydrateVideo(firstVisible);
      }
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            if (!savesData()) hydrateVideo(entry.target);
          });
        },
        { rootMargin: '500px 0px' }
      );

      templates.forEach((template) => observer.observe(template));
    } else if (!savesData()) {
      templates.forEach(hydrateVideo);
    }

    templates.forEach((template) => {
      const container = template.closest('.slide__image-container');
      if (!container) return;
      container.addEventListener('pointerenter', () => hydrateVideo(template), { once: true });
      container.addEventListener('click', () => hydrateVideo(template), { once: true });
    });

    if (document.readyState === 'complete') {
      runWhenIdle(hydrateFirst);
    } else {
      window.addEventListener('load', () => runWhenIdle(hydrateFirst), { once: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeferredVideos, { once: true });
  } else {
    initDeferredVideos();
  }

  document.addEventListener('shopify:section:load', initDeferredVideos);
})();
